
import { AssignmentReturned } from '@mui/icons-material';
import WarehouseIcon from '@mui/icons-material/Warehouse';

import CancelIcon from '@mui/icons-material/Cancel';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { ReactComponent as Amazon } from '../../../styles/svg/marketplace/amazon-app-icon.svg';

export const relationOrdersConfig = (orderTotals, hasAmazonManagePermission) => {
    return {
        orders:  {
            title: 'processing',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.open + (orderTotals.paused ?? 0) + (orderTotals.postponed ?? 0)})
        },
        ordersActionRequired: {
            title: 'action_required',
            icon: <WarningAmberIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.action})
        },
        ordersShipped: {
            title: 'shipped',
            icon: <LocalShippingIcon/>,
            isSingleDataGrid: true,
        },
        ordersBackordered: {
            title: 'backordered',
            icon: <ScheduleSendIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.backorder})
        },
        orderSnoozed: {
            title: 'snoozed',
            icon: <ScheduleSendIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.snoozed})
        },
        ordersCancelled: {
            title: 'cancelled',
            icon: <CancelIcon/>,
            isSingleDataGrid: true,
        },
        ordersAll: {
            title: 'all_orders',
            icon: <FormatListBulletedIcon/>,
            isSingleDataGrid: true,
        },
        ordersBol: {
            title: 'bol_lvb',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        // Gated behind amazon_manage: every FBA endpoint 403s without it, so an ungated tab would just render errors.
        ...(hasAmazonManagePermission && {
            ordersAmazonFba: {
                title: 'amazon_fba',
                icon: <Amazon width={20} height={20} />,
                isSingleDataGrid: true,
            }
        }),
        orderlogs:  {
            title: 'order_import',
            icon: <AssignmentReturned/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.import})
        },
        orderlines:  {
            title: 'orderlines',
            icon: <AssignmentReturned/>,
            isSingleDataGrid: true,
        },
    };
};
